import React from "react"
import PropTypes from "prop-types"

import { Box } from "components/common/index"

const LandingMargin = ({ element }) => (
  <Box contain id={element.anchor_name} mt={`${element.margin}px`} />
)

LandingMargin.propTypes = {
  element: PropTypes.object
}

export default LandingMargin
